import { SearchResultsModel } from '@/services/GeneratedApi';
import { SearchCriteriaModel, SearchTableStateModel, StoreConstants, TableFilterModel, TableSortModel } from '@/types';
import { SearchState } from '@/types/store/search';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<SearchState> = {
  [StoreConstants.Search.Mutations.SetSearchCriteria](state, searchCriteria: SearchCriteriaModel & { userId: number }) {
    state.searchCriteria = searchCriteria;
  },
  [StoreConstants.Search.Mutations.SetSelectedItems](state, keys: string[]) {
    state.searchResults.selectedItemKeys = keys;
  },
  [StoreConstants.Search.Mutations.SetCurrentPage](state, page: number) {
    state.searchResults.currentPage = page;
  },
  [StoreConstants.Search.Mutations.SetItemsPerPage](state, count: number) {
    state.searchResults.itemsPerPage = count;
  },
  [StoreConstants.Search.Mutations.SetShowSorting](state, show: boolean) {
    state.searchResults.showSorting = show;
  },
  [StoreConstants.Search.Mutations.SetShowFilters](state, show: boolean) {
    state.searchResults.showFilters = show;
  },
  [StoreConstants.Search.Mutations.SetAppliedFilterOptions](state, options: TableFilterModel[]) {
    state.searchResults.appliedFilterOptions = options;
  },
  [StoreConstants.Search.Mutations.SetAppliedSortOptions](state, options: TableSortModel[]) {
    state.searchResults.appliedSortOptions = options;
  },
  [StoreConstants.Search.Mutations.SetColumnOrders](state, orders: string[]) {
    state.searchResults.columnOrders = orders;
  },
  [StoreConstants.Search.Mutations.SetSplitConfiguration](state, config: number) {
    state.searchResults.splitConfiguration = config;
  },
  [StoreConstants.Search.Mutations.SetSearchResponse](state, response: SearchResultsModel) {
    state.searchResults.response = response;
  },
  [StoreConstants.Search.Mutations.SetUnsortedItems](state, unsortedItems: any[]) {
    state.searchResults.unsortedItems = unsortedItems;
  },
  [StoreConstants.Search.Mutations.SetLastViewedDocument](state, { cabinetId, documentId }) {
    state.searchResults.documentId = documentId;
    state.searchResults.cabinetId = cabinetId;
  },
  [StoreConstants.Search.Mutations.UnloadSearchResults](state) {
    const initState = {
      selectedItemKeys: [],
      currentPage: 1,
      itemsPerPage: 0,
      showSorting: false,
      showFilters: false,
      appliedFilterOptions: [],
      appliedSortOptions: [],
      columnOrders: [],
      splitConfiguration: 0,
      response: state.searchResults.response,
      unsortedItems: [],
      documentId: 0,
      cabinetId: ''
    } as SearchTableStateModel;
    Object.assign(state.searchResults, initState);
  },
  [StoreConstants.Search.Mutations.ResetSearchResults](state) {
    const initState = {
      ...state.searchResults,
      selectedItemKeys: [],
      currentPage: 1,
      response: state.searchResults.response,
      unsortedItems: [],
      documentId: 0,
      cabinetId: ''
    } as SearchTableStateModel;
    Object.assign(state.searchResults, initState);
  }
};
